module.exports = __webpack_public_path__ + "img/sap.eada5ffc.png";